<template>
  <!-- 考勤配置-设置施工班组 -->
  <div class="config-classmate">
    <el-dialog v-model="showAddDialog" dialog-width="2" :title="configData.configName + '设置项目/工地/班组'" :close-on-click-modal="false">
      <dialog-table>
        <project-site-classmate-show :tree-data="projectClassTree" @select-one="clickTreeNode">
          <template #default="{data}">
            <span v-if="data.configName" class="tree-config-name">{{data.configName}}</span>
            <yq-icon name="element-ui_check" v-if="data.checked" style="color: #1BAB3D"/>
          </template>
        </project-site-classmate-show>
      </dialog-table>
      <template #footer>
        <page-button @click="showAddDialog = false">取消</page-button>
        <page-button el-type="primary" @click="saveConfigProjectClass">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import DialogTable from "@/components/h5/layout/DialogTable.vue";
import attendConfigApi from "@/api/dz-luqiao/attendConfigApi";
import YqIcon from "@/components/YqIcon.vue";
import ProjectSiteClassmateShow from "@/views/h5/luqiao/display/ProjectSiteClassmateShow.vue";
export default {
  props: {
    configData: {default: () => {}}, // 配置id
    configListAll: {default: () => []}, // 全部的考勤配置
  },
  name: "AC",
  components: {
    YqIcon, DialogTable, ProjectSiteClassmateShow
  },
  data() {
    return {
      showAddDialog: false,
      projectClassTree: [], // 把项目，工地，班组整理成树的树形结构
    };
  },
  created() {
  },
  methods: {
    // 保存项目，工地，班组的打卡配置
    saveConfigProjectClass() {
      let data = {
        configId: this.configData.id,
        projectList: [],
        siteList: [],
        classmateList: []
      };
      this.getDataByLevel(this.projectClassTree, 1, data);
      // 保存数据
      attendConfigApi.saveConfigProjectClass(data).then(() => {
        this.showAddDialog = false;
      })
    },
    getDataByLevel(list, level, data) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].children && list[i].children.length > 0) {
          this.getDataByLevel(list[i].children, level + 1, data);
        }
        if (!list[i].checked) { // 未选中
          continue;
        }
        if (level === 1) {
          data.projectList.push(list[i].id);
        } else if (level === 2) {
          data.siteList.push(list[i].id);
        } else if (level === 3) {
          data.classmateList.push(list[i].id);
        }
      }
    },
    // 显示添加施工班组的对话框
    toShowAdd() {
      this.showAddDialog = true;
      attendConfigApi.queryProjectClassmateTree().then(list => {
        // dataList里面的classmate，是已经被选中的数据
        this.listSelected(list, 1);
        console.log(list);
        this.projectClassTree = list
      });
    },
    // 这个list，数据是否被选中了,返回这个list是否被全部选中
    listSelected(list, level) {
      for (let i = 0; i < list.length; i++) {
        // 找到配置
        for (let j = 0; j < this.configListAll.length; j++) {
          if (list[i].remark1 === this.configListAll[j].id) {
            list[i].configName = this.configListAll[j].configName;
          }
        }
        list[i].checked = list[i].remark1 === this.configData.id; // 被选中
        if (list[i].children && list[i].children.length > 0) {
          this.listSelected(list[i].children, level + 1);
        }
      }
    },
    // 根据id，找到this中的数据
    getDataById(list, id) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          return list[i];
        }
        // 如果有下级
        if (list[i].children && list[i].children.length > 0) {
          let d = this.getDataById(list[i].children, id);
          if (d.id) {
            return d;
          }
        }
      }
      return {};
    },
    // 点击树节点
    clickTreeNode(n) {
      let node = this.getDataById(this.projectClassTree, n.id);
      node.checked = !node.checked;
      if (node.checked) {
        // 被选中时，如果下级数据为空，选中
        if (node.children && node.children.length > 0) {
          this.clickTreeNode2(node.children);
        }
      }
    },
    clickTreeNode2(list) {
      for (let i = 0; i < list.length; i++) {
        if (!list[i].checked && !list[i].remark1) {
          list[i].checked = true;
        }
        if (list[i].children && list[i].children.length > 0) {
          this.clickTreeNode2(list[i].children);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tree-config-name{
  margin: 0 5px;
  font-size: 10px;
  border: 1px solid var(--el-color-success-light-3);
  background: var(--el-color-success-light-5);
  color: var(--yq-font-color-tips);
  padding: 0 5px;
}


//:deep(.el-tree) {
//  .el-tree-node__content{
//    justify-content: space-between;
//    box-sizing: border-box;
//  }
//  .node-info{
//    flex: 1;
//    display: flex;
//    justify-content: space-between;
//  }
//}

</style>